module.exports = __webpack_public_path__ + "img/head.fe2980e2.png";